import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Mountain, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../../context/AuthContext";
import { formatApiError } from "../../lib/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Accesso effettuato");
      nav("/admin");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-fir-deep px-4">
      <div className="w-full max-w-md bg-ivory rounded-3xl p-10 shadow-2xl">
        <div className="flex items-center gap-2 justify-center mb-2">
          <Mountain className="text-gold" size={32} />
          <span className="font-display text-3xl text-fir">Appartamenti in Val di Sole</span>
        </div>
        <p className="text-center text-fir-deep/60 mb-8">Area Proprietario</p>
        <form onSubmit={submit} className="space-y-4">
          <input type="email" data-testid="login-email" placeholder="Email" value={email}
            onChange={(e) => setEmail(e.target.value)} className="input-alpine w-full" required />
          <input type="password" data-testid="login-password" placeholder="Password" value={password}
            onChange={(e) => setPassword(e.target.value)} className="input-alpine w-full" required />
          <button type="submit" data-testid="login-submit" disabled={loading}
            className="gold-btn w-full py-3.5 rounded-xl flex items-center justify-center gap-2">
            {loading ? <Loader2 className="animate-spin" size={18} /> : "Accedi"}
          </button>
        </form>
      </div>
    </div>
  );
}
